/* eslint-disable react/display-name */
import React from "react";
import PropTypes from "prop-types";

const Card = React.forwardRef((props, ref) => {
  return (
    <div className="card" style={props.style} ref={ref}>
      {props.isHeader ? props.header : null}
      <div className="card-body">{props.children}</div>
    </div>
  );
});

Card.propTypes = {
  children: PropTypes.any,
  style: PropTypes.any,
  isHeader: PropTypes.bool,
  header: PropTypes.any,
  headerTitle: PropTypes.any
};

export default Card;
